import InputPhoneNumber from 'components/InputPhoneNumber/InputPhoneNumber.component';
import ContainerMessageOtp from 'components/OtpModal/partials/ContainerMessageOtp.component';
import { useFormikContext } from 'formik';
import { otpCodeFieldName } from 'pages/profile/profile.config';
import { forwardRef, memo, Ref } from 'react';
import { OtpFormValue } from '../OtpModal/OtpModal.config';
import { FlexOtp, OtpInputField } from './Otp.style';

export interface OTPInputProps {
  length: number;
  autoFocus?: boolean;
  isNumberInput?: boolean;
  disabled?: boolean;
}

function Otp(props: OTPInputProps, ref: Ref<HTMLInputElement>) {
  const { length } = props;
  const { errors } = useFormikContext<OtpFormValue>();

  const externalMessage = errors[otpCodeFieldName];

  const hasFormError = !!externalMessage?.length;

  return (
    <>
      <FlexOtp isFormErrorPresent={hasFormError}>
        <OtpInputField
          inputComponent={InputPhoneNumber}
          name={otpCodeFieldName}
          label={'lbl.otp.insertCode'}
          type="tel"
          maxLength={length}
          analyticsName={'otpCode'}
          isPresentIconInsideInput={false}
          ref={ref}
        />
      </FlexOtp>
      <ContainerMessageOtp
        externalMessage={externalMessage}
        isError={hasFormError}
      />
    </>
  );
}

const OTPInput = memo(forwardRef(Otp));
export default OTPInput;
